<template>
  <div :class="{'is-pass': isDueDate, 'is-expiring-soon': isExpiringSoon}">{{ displayDate }}</div>
</template>

<script>
export default {
  name: 'TableCellPaymentDeadline',
  props: {
    payload: {
      type: Object
    }
  },
  computed: {
    displayDate () {
      return this.$moment(this.payload.payment_deadline).format('DD/MM/yyyy')
    },
    isDueDate () {
      return this.$moment().isAfter(this.payload.payment_deadline)
    },
    isExpiringSoon () {
      // Check if deadline is within 2 weeks but hasn't passed yet
      const now = this.$moment()
      const deadline = this.$moment(this.payload.payment_deadline)
      const twoWeeksFromNow = now.clone().add(14, 'days')

      return twoWeeksFromNow.isAfter(deadline) && !this.isDueDate
    }
  }
}
</script>

<style scoped>
.is-pass {
  color: red;
  font-weight: bold;
}

.is-expiring-soon {
  color: #8B4513;
  font-weight: bold;
}
</style>
